module.exports = __webpack_public_path__ + "static/media/play-background-5.8a707b94.mp3";